import React, { useCallback } from 'react'

import { BookMeetingForm } from 'Components/Blocks/Forms'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Column, Modal, Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import { Container } from './styles'

type Props = {
  isOpened?: boolean
  onClose?: () => void
}

function BookMeetingModal({ isOpened, onClose }: Props) {
  const { isMobile } = useResponsiveLayout()

  const handleClose = useCallback(() => {
    onClose?.()
  }, [onClose])

  return (
    <Modal isOpen={isOpened} onClose={handleClose}>
      <Container
        flexDirection={isMobile ? 'column' : 'row'}
        maxWidth={['90dvw', '90dvw', '90dvw', '90dvw', '820px']}
        p={[5, 5, 7, 7, 9]}
      >
        <Column alignCenter width={[1, 1, 1 / 2]}>
          <SubsectionTitle
            centered={isMobile}
            subtitle="Schedule a meeting with our team to discuss membership"
            title="Book a Meeting"
          />

          <Text
            body
            center={isMobile}
            mt={5}
            screen14={isMobile}
            screen18={!isMobile}
          >
            Choose a convenient time to connect with us. During the meeting
            we’ll answer your questions and walk you through the benefits of
            membership.
          </Text>
        </Column>

        <Column width={[1, 1, 1 / 2]}>
          <BookMeetingForm />
        </Column>
      </Container>
    </Modal>
  )
}

export default BookMeetingModal
